import { Contrato } from "./contrato";

export class Cliente {
    nuTransacao: string;
    nuProtocolo: string;
    cdRetorno: string;
    cdMsgemRetorno: string = '0';
    dsMsgemRetorno: string;
    dsMsgemMainframeRetorno: string;
    nuControle: string;
    nuDocumento: string;
    cdCtrlProcessamento: string;
    textoAutenticacao: string;
    cdIndcdTransacao: string;
    lstMensagem: string[];
    nmCliente: string;
    cdTipoCpfCnpj: string;
    nuCpfCnpj: string;
    nuCpfCnpjFormatado: string;
    contrato: Contrato;
    listaContrato: Contrato[];
    indcdTipoContrato: string = '';
    indcdContratoCdc: boolean;
    indcdContratoLeasing: boolean;
    cdIndOperacao: string;

    constructor() { }
}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/modelo/cliente.ts